<script setup lang="ts">
import { useModal } from "@/Utils/use-modal";
import AppButton from "@/Components/Shared/button/AppButton.vue";
import AppReviewLikers from "@/Components/App/reviews/AppReviewLikers.vue";
import {
    ButtonColor,
    ButtonSize,
    ButtonVariant,
} from "@/Components/Shared/button";

type Props = {
    reviewId: string;
    variant?: ButtonVariant;
    size?: ButtonSize;
    color?: ButtonColor;
    disabled?: boolean;
};
const {
    reviewId,
    variant = undefined,
    size = undefined,
    color = undefined,
    disabled = false,
} = defineProps<Props>();

const emit = defineEmits(["close", "success"]);

const { openModal } = useModal();

const openReviewLikersModal = () => {
    openModal({
        component: AppReviewLikers,
        title: `Deze review is geliked door:`,
        props: {
            reviewId: reviewId,
        },
    });
};
</script>

<template>
    <AppButton
        :variant="variant"
        :size="size"
        :color="color"
        :disabled="disabled"
        @click="openReviewLikersModal"
    >
        <slot />
    </AppButton>
</template>
